/*
 * Copyright © 2024 Himitsu Lab Limited. All Rights Reserved.
 */

/* eslint-disable prettier/prettier */
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  "addExternalCamera": "Add External Camera",
  "attach": "Attach",
  "camera": "Camera",
  "cameraOn": "Camera On",
  "cameraOff": "Camera Off",
  "characters": "characters",
  "close": "Close",
  "coHost": "Co-host",
  "currentStepUpPrice": "Current step-up price",
  "custom": "Custom",
  "doYouNeedToEndTheMeeting": "Do you need to end the meeting?",
  "doYouWantToLeaveTheMeeting": "Do you want to leave the meeting?",
  "doYouWantToSave": "Do you want to save",
  "enableDualDeviceSelection": "Enable Dual Device Selection",
  "end": "End",
  "fileSizeExceedsLimit": "File size exceeds the limit",
  "fullScreen": "Full Screen",
  "groupChat": "Group Chat",
  "gridView": "Grid View",
  "handRaise": "Hand Raise",
  "host": "Host",
  "hostGrantedPermissionToTalk": "Host granted permission to talk",
  "hostRemovedPermissionToTalk": "Host removed permission to talk",
  "hostStartedRecordingTheScreen": "Host started recording the screen",
  "hostStartedRecording": "Host started recording",
  "hostView": "Host View",
  "initialStepUp": "Initial step-up",
  "language": "Language",
  "leave": "Leave",
  "limitPleaseUploadASmallerFileOrUploadFilesInADriveAndShareTheLink": "Limit. Please upload a smaller file or upload files in a drive and share the link",
  "liveChat": "Live Chat",
  "meetingWillEndIn": "Meeting will end in",
  "message": "Message",
  "messageLengthExceeds": "Message length exceeds",
  "mic": "Mic",
  "microphoneOn": "Microphone On",
  "microphoneOff": "Microphone Off",
  "minutes": "minutes",
  "multiSessionDoYouWantToLeave": "Multi-session. Do you want to leave?",
  "muteAll": "Mute All",
  "noResultsFound": "No results found",
  "ok": "OK",
  "onlyImagesAudioAndPdfFilesAreSupported": "Only images, audio, and PDF files are supported",
  "others": "Others",
  "participants": "Participants",
  "pin": "Pin",
  "pip": "PIP",
  "pleaseTurnOnYourMicToStartRecording": "Please turn on your mic to start recording",
  "privateChat": "Private Chat",
  "raisedTheirHand": "raised their hand",
  "recordingInProgress": "Recording in progress",
  "save&NotifyMe": "Save & Notify Me",
  "screenShare": "Screenshare",
  "screenShareOn": "Screenshare On",
  "screenShareOff": "Screenshare Off",
  "searchParticipants": "Search participants",
  "send": "Send",
  "settings": "Settings",
  "shareShow": "Share Show",
  "staged": "Staged",
  "startRecording": "Start Recording",
  "stepUp": "Step-up",
  "stepUpAmountError": "Step-up amount error",
  "stepUpAmountCannotBeLessThanTheOngoingStepUpAmountOf": "Step-up amount cannot be less than the ongoing step up amount of",
  "stepUpCompletedAt": "Step-up completed at",
  "streamKey": "Stream Key",
  "stopRecording": "Stop Recording",
  "theFileSizeExceedsThe": "The file size exceeds the",
  "toSpeakRaiseYourHandAndWaitForTheHostToUnmuteYou": "To speak, raise your hand, and wait for the host to unmute you",
  "toShareYourScreenKindlyRequestTheHostToUnmuteYou": "To share your screen, kindly request the host to unmute you",
  "typeAMessage": "Type a message",
  "unmute": "Unmute",
  "unmuteAll": "Unmute All",
  "unpin": "Unpin",
  "unsupportedFileType": "Unsupported File Type",
  "waitForHost": "Wait for host",
}
